import { SettingOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { SignedIn, SignedOut, SignInButton, UserButton, useUser } from '@clerk/clerk-react';
import { useNavigate } from 'react-router';
import styles from './index.module.scss';

export function HeaderRightContent() {
  const navigate = useNavigate();
  const { user } = useUser();
  const role = (user?.publicMetadata as { role?: string } | undefined)?.role;

  return (
    <Space className={styles.right} size="middle">
      <SignedIn>
        {role === 'admin' && (
          <Button type="text" icon={<SettingOutlined />} onClick={() => navigate('/admin')}>
            Admin
          </Button>
        )}
        <div className={styles.userButtonWrap}>
          <UserButton />
        </div>
      </SignedIn>

      <SignedOut>
        <SignInButton mode="modal">
          <Button type="primary">Sign In</Button>
        </SignInButton>
      </SignedOut>
    </Space>
  );
}
